module.exports = __FOREMAN_VENDOR__CONNECTED_REACT_ROUTER__;